module.exports = __webpack_public_path__ + "img/bz.0e7f7596.svg";